module.exports = __webpack_public_path__ + "static/media/allison-khan-ali.f38e4059.png";